/* --------------------------------------------------------------------------------------
   common.service.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class commonService {
  /*@ngInject*/
  constructor (appSettings, $window, $timeout) {
    this.appSettings = appSettings
    this.$window = $window
    this.$timeout = $timeout
  }
  setNavyBackground () {
    if (!$('body').hasClass('navy'))
        $('body').addClass('xrx-background navy')
  }
  setDefaultBackground () {
    $('body').removeClass('xrx-background navy')
  }
  getScreenHeight() {
    return this.$window.screen.height
  }
  getScreenWidth() {
    return this.$window.screen.width
  }
  updateView() {
    return this.$timeout(() => 1 == 1)
  }
  getApiUrl() {
    let host = this.$window.location.host
    let stage = 'dev'
    if (host.includes('app.xeroxtestgrading.com'))
        stage = 'prod'
    if (host.includes('-test'))
        stage = 'test'
    if (host.includes('-staging'))
        stage = 'staging'
  }
  getLanguage() {
    const availableLanguages = ['en', 'fr', 'es']
    const currentLang = 'es'//navigator.language.split('-')[0]
    return availableLanguages.includes(currentLang) ? currentLang : 'en'
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/common.service.js